// 渲染是否同意消息
import React, { memo } from 'react'
import styled from 'styled-components'

const TextMsgOrd = styled.span`
  display: inline-block;
  margin-top: 8px;
  padding: 16px;
  background: #E9E9E9;
  border-radius: 8px;
  color: #595959;
`

const RenderAgreeMsg = memo((props) => {
  const { value } = props
  let message = value.messageContent ? JSON.parse(value.messageContent) : {}
  return (
    <TextMsgOrd
      style={value.sendType === 2 ? { background: "rgba(82, 196, 26, 0.1)" } : {}}
    >
      {
        message.type === 1 ? '对方同意存档会话内容' : '对方不同意存档'
      }
    </TextMsgOrd>
  )
})

export default RenderAgreeMsg
